import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import { showCreatedSticker } from "../../../store/create-llama/actions";
import StickersComponentsCongratulations from "../../components/congratulations";
import {
  createLlamaShowAnimationSelector
} from "../../../store/create-llama/selectors";
import { isMemorialType } from "../../../store/sticker-show/selectors";
class StickersScreensNewStickerFinish extends PureComponent {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <StickersComponentsCongratulations
        title={this.props.t('title')}
        viewItPressed={this.props.showCreatedSticker}
        showAnimation={this.props.showAnimation}
        isMemorialTheme={ this.props.isMemorialTheme }
        history={ this.props.history }
      />
  );
  }
}

const mapStateToProps = (state) => {
  return {
    showAnimation: createLlamaShowAnimationSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    showCreatedSticker: () => dispatch(showCreatedSticker())
  }
};

export default compose(
  withTranslation('scr-new-sticker-finish'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerFinish);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/new-sticker-finish/index.jsx